export default {
    isLoggedIn: (state: { isLoggedIn: any; }) => state.isLoggedIn,
    isUrlAvatar: (state: { isUrlAvatar: any; }) => state.isUrlAvatar,
    isLoading: (state: { isLoading: any; }) => state.isLoading,
};
